import React, { useEffect, useState } from 'react'
import './AdminPersonnelList.css'
import { NavLink } from 'react-router-dom'
import AdminButton from '../../shared/components/UIElements/AdminButton'
import AdminNavigation from './AdminNavigation'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'

const AdminPersonnelList = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [loadedPersonnel, setLoadedPersonnel] = useState()
	const [gamesScheduledArray, setGamesScheduledArray] = useState([])

	//First, lets tap into the following route on the backend to get all personnel:
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + `/admin/personnel`
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				console.log('responseData: ' + JSON.stringify(responseData))

				setLoadedPersonnel(responseData.allPersonnel)
				setGamesScheduledArray(responseData.gamesScheduledArray)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [])

	const errorHandler = () => {
		setError(null)
	}

	/* const getGamesScheduled = async (personnel) => {
		let numberOfGames
		//console.log('games scheduled for :' + JSON.stringify(personnel))
		const personnelId = personnel._id
		setIsLoading(true)
		try {
			const response = await fetch(
				process.env.REACT_APP_BACKEND_URL +
					`/admin/${personnelId}/gamesScheduled`
			)

			const responseData = await response.json()

			if (!response.ok) {
				throw new Error(responseData.message)
			}
			console.log(
				'numberOfGames: ' + JSON.stringify(responseData.numberOfGames)
			)
			numberOfGames = responseData.numberOfGames
			setIsLoading(false)
			return numberOfGames
		} catch (err) {
			setError(err.message)
		}
		setIsLoading(false)
	} */

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={errorHandler} />
			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}
			{!isLoading && loadedPersonnel && gamesScheduledArray && (
				<div className='Teams' style={{ marginBottom: '3rem' }}>
					<AdminNavigation />
					<h1>Personnel</h1>
					<p style={{ textAlign: 'center' }}>
						Use this page to view, create, or edit referees and scorekeepers
					</p>
					<table id='teams'>
						<thead>
							<tr>
								<th>Referee/Scorekeeper Name</th>
								<th>Games Scheduled</th>
								<th></th>
								<th></th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{loadedPersonnel.map((personnel, key) => {
								return (
									<tr key={key}>
										<td>
											{personnel.firstName} {personnel.middleInitial}{' '}
											{personnel.lastName}
										</td>
										<td>{gamesScheduledArray[key]}</td>
										<td></td>
										<td></td>
										<td>
											<NavLink
												className='navlinks'
												to={`/admin/updatePersonnel/${personnel._id}`}
												exact
											>
												Edit
											</NavLink>
										</td>
									</tr>
								)
							})}
							<tr style={{ backgroundColor: '#e0e0e0' }}>
								<AdminButton
									to={`/admin/personnel/new`}
									exact
									style={{
										color: 'white',
										textDecoration: 'none',
									}}
								>
									Add new Ref/Scorekeeper
								</AdminButton>
							</tr>
						</tbody>
					</table>
				</div>
			)}
		</React.Fragment>
	)
}

export default AdminPersonnelList
